import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { IGirafePanel } from '@geogirafe/lib-geoportal/core';

export default class ReportPanelComponent extends GirafeHTMLElement implements IGirafePanel {
  templateUrl = './template.html';
  styleUrls = ['../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', './style.css'];

  isPanelVisible = false;
  panelTitle = 'Reporte';
  panelTogglePath = 'extendedState.reportPanel.visible';

  constructor() {
    super('report-panel-component');
  }

  registerEvents() {
    this.subscribe(/oauth\.userInfo.*/, () => this.render());
  }

  public togglePanel(visible: boolean) {
    if (this.isPanelVisible == visible) return;
    this.isPanelVisible = visible;
    this.render();
  }

  override connectedCallback() {
    super.connectedCallback();
    this.state.extendedState.reportPanel = {
      visible: false
    };
    this.render();
    this.registerEvents();
  }

  override render(): void {
    if (this.isPanelVisible) {
      super.render();
    } else {
      this.hide();
    }
  }
}
